import type TriggerEngine from "../../TriggerEngine";

import type { EventSourceResult } from "../../TriggerEngine.interfaces";

/**
 * Wires the integrations EventBus (follow/sub/donation/raid/chat from Twitch/Kick/YouTube)
 * into the TriggerEngine.
 *
 * Implementation: Fase 6 (the eventBusService client) calls TriggerEngine.fireEvent("event_follow", payload)
 * directly when an SSE event arrives — NOT via this wire function.
 *
 * This stub exists so EVENT_SOURCE_MAP doesn't error on the new events.
 * Returns no-op unsubscribers since the actual subscription happens in eventBusService.
 */
export const wireEventBusEvents = (
  _engine: TriggerEngine,
): EventSourceResult => {
  // No-op: events are dispatched directly by eventBusService.fireEvent calls
  return { unsubscribers: [] };
};
